import React, { useEffect, useState, useCallback, useContext } from "react";
import {
	Container,
	Accordion,
	Alert,
	Form,
	Card,
	Button,
	Table,
} from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { USER_TYPE } from "../../utils/constants";

import { AppContext } from "../../context/appContext";

const AccountList = () => {
	const navigate = useNavigate();
	const { setGlobalLoading } = useContext(AppContext);

	const [userList, setUserList] = useState([]);

	const fetchUserList = useCallback(async () => {
		try {
			setGlobalLoading(true);
			const response = await axios.get(
				"https://vwisdwl4dh.execute-api.us-east-1.amazonaws.com/v1/manageUsers-dev",
			);

			if (
				response.data &&
				response.data.userList &&
				Array.isArray(response.data.userList)
			) {
				setUserList(response.data.userList); // ✅ Ensure we only take 10 results
				setGlobalLoading(false);
			} else {
				console.error("❌ API returned an unexpected format:", response.data);
				setUserList([]); // Set empty array if no valid data
				setGlobalLoading(false);
			}
		} catch (error) {
			console.error("❌ Error fetching bakeries:", error);
		}
	}, [setGlobalLoading]);

	useEffect(() => {
		fetchUserList();
	}, [fetchUserList]);

	return (
		<Container className="py-5">
			<Card className="shadow-sm" style={{ borderRadius: "15px" }}>
				<Card.Body style={{ padding: "30px" }}>
          <Button
            variant="primary"
            className="mb-3"
            onClick={() => navigate("/control/account/create")}>
            Create Account
          </Button>
          <Accordion defaultActiveKey="0">
            {
              userList?.map((u, i) => {
                return (
                  <Accordion.Item key={i.toString()} eventKey={i.toString()}>
                    <Accordion.Header>{u.group}</Accordion.Header>
                    <Accordion.Body>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Email</th>
                            <th>Verified</th>
                            {
                              u.group == USER_TYPE.BAKERY
                              &&  
                              <>
                                <th>Bakery</th>
                                <th></th>
                              </>                          
                            }
                          </tr>
                        </thead>
                        <tbody>
                          {u?.users?.map((d, i) => {
                            return (
                              <tr key={i.toString()}>
                                <td>{i + 1}</td>
                                <td>{d.username}</td>
                                <td>{d.emailVerified === "true" ? "verified" : "-"}</td>
                                {
                                  u.group == USER_TYPE.BAKERY
                                  &&
                                  <>
                                    <td>
                                      {d.bakeryStore?.bakeryName
                                        ? d.bakeryStore?.bakeryName
                                        : "-"}
                                    </td>
                                    <td>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          navigate(`/control/bakery/${d.userSub}`)
                                        }>
                                        {d.bakeryStore ? "Modify" : "Create"} Bakery
                                      </Button>
                                    </td>
                                  </>
                                }
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })
            }
          </Accordion>
        </Card.Body>
			</Card>
		</Container>
	);
};

export default AccountList;
